import React from 'react';
import { Container, Title } from './styles';
export default function AdminSection(_a) {
    var title = _a.title, children = _a.children;
    return (React.createElement(Container, null,
        React.createElement(Title, null, title),
        children));
}
